import React from 'react';
import { useDispatch } from 'react-redux';

import { TableRow, TableCell, IconButton, Tooltip } from '@material-ui/core';
import { Edit, Visibility } from '@material-ui/icons';
import { isBoolean, isUndefined, find, isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import { Dialog, InputTransparent } from '..';

import { Container } from './style';

export default function Tbody({
  columns,
  data,
  selected,
  addedItemHandler,
  unique,
  remove,
  edit,
  edition,
  model,
  buttons,
  cell,
  onCallback,
  size,
}) {
  const dispatch = useDispatch();

  function handleCheckItem() {
    addedItemHandler(data);
    onCallback(data);
  }

  function removeItem(param) {
    if (!isBoolean(remove)) {
      const url = [];

      unique.map((un) => {
        url.push(param[un]);

        return true;
      });

      dispatch(remove(url.join('/')));
    }
  }

  /**
   * convert value in array field or return value default
   *
   * @param {Array} items
   * @param {String} value
   */
  function handleConvertItem(items, value) {
    const obj = find(items, (i) => i.label === value);

    if (obj) {
      return obj.value;
    }

    return value;
  }

  function handleFormatItem(obj, column) {
    const { format, converter } = obj;

    if (!isUndefined(format)) {
      return obj.format(column);
    }

    if (!isUndefined(converter)) {
      return handleConvertItem(obj.converter, column);
    }

    return column;
  }

  return (
    <TableRow
      hover
      onClick={handleCheckItem}
      className={selected ? 'active' : ''}
      style={{ position: 'sticky' }}
    >
      {columns.map((column) => (
        <TableCell key={column.id} align={column.align || 'left'}>
          {data.edit && isFunction(cell) ? (
            <InputTransparent name={column.id} row={data} onSubmit={cell} />
          ) : (
            handleFormatItem(column, data[column.id])
          )}
        </TableCell>
      ))}

      {selected && !isFunction(cell) && (
        <Container size={size}>
          {edition && (
            <Tooltip title={t('s.geral.botaoalterar')}>
              <IconButton size="small" onClick={() => edit()}>
                <Edit />
              </IconButton>
            </Tooltip>
          )}

          {remove && <Dialog callback={() => removeItem(data)} />}

          {model && (
            <Tooltip title={t('s.geral.botaomodelo')}>
              <IconButton size="small" onClick={() => edit()}>
                <Visibility />
              </IconButton>
            </Tooltip>
          )}

          {buttons.map((button) => (
            <Tooltip title={button.title} key={button.title}>
              <IconButton
                size="small"
                onClick={() => button.action(data)}
                disabled={!!button.disabled}
              >
                {button.icon}
              </IconButton>
            </Tooltip>
          ))}
        </Container>
      )}
    </TableRow>
  );
}

Tbody.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  selected: PropTypes.bool.isRequired,
  addedItemHandler: PropTypes.func.isRequired,
  unique: PropTypes.arrayOf(PropTypes.string).isRequired,
  remove: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
  edit: PropTypes.func.isRequired,
  edition: PropTypes.bool.isRequired,
  model: PropTypes.bool.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.any).isRequired,
  cell: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]).isRequired,
  onCallback: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
};
